var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15.1074L11.5625 10.9199C12.4688 9.82617 12.9688 8.41992 12.9688 6.88867C12.9688 3.32617 10.0312 0.388672 6.46875 0.388672C2.875 0.388672 0 3.32617 0 6.88867C0 10.4824 2.90625 13.3887 6.46875 13.3887C7.96875 13.3887 9.375 12.8887 10.5 11.9824L14.6875 16.1699C14.8438 16.3262 15.0312 16.3887 15.25 16.3887C15.4375 16.3887 15.625 16.3262 15.75 16.1699C16.0625 15.8887 16.0625 15.4199 15.75 15.1074ZM1.5 6.88867C1.5 4.13867 3.71875 1.88867 6.5 1.88867C9.25 1.88867 11.5 4.13867 11.5 6.88867C11.5 9.66992 9.25 11.8887 6.5 11.8887C3.71875 11.8887 1.5 9.66992 1.5 6.88867Z",
    fill: "#333335"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search.5cb66962.svg";
export { ForwardRef as ReactComponent };